import React, { Component } from 'react';
import PageTitle from '@/components/PageTitle';
import TableActionBar from '@/components/TableActionBar/index';
import { EditOutlined, CheckCircleTwoTone, CloseCircleTwoTone } from '@ant-design/icons';
import { Table, Modal, Tooltip } from 'antd';
import { connect } from 'react-redux';
import WarehouseForm from './ProductWarehouseForm';
import qs from 'qs';
import _ from 'lodash';
import { checkPermission } from '@/utils/permission';
import { cleanObject, isValidDate, stripHtml } from '@/utils/helpers';
import HtmlParser from 'react-html-parser';
import TextTruncate from 'react-text-truncate';
import { getAllProductWarehouse, removeProductWarehouse, getOneProductWarehouse } from '@/redux/actions/ProductWarehouseAction';

const routes = [
    {
        path: '/',
        breadcrumbName: 'Trang chủ',
    },
    {
        path: '/warehouse',
        breadcrumbName: 'Danh sách kho',
    }
]

class WarehouseList extends Component {

    constructor() {
        super();
        this.state = {
            isLoading: false,
            selectedRowKeys: [],
            isOpenForm: false,
            currentItem: null
        }
    }

    componentDidMount() {
        var query = qs.parse(this.props.location.search.slice(1));
        this.setState({
            isLoading: true
        });
        this.props.getAllProductWarehouse(query).then(() => {
            this.setState({
                isLoading: false
            })
        })
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (nextProps.location.search !== this.props.location.search) {
            var query = qs.parse(nextProps.location.search.slice(1));
            this.setState({ isLoading: true });
            this.props.getAllProductWarehouse(query).then(() => {
                this.setState({ isLoading: false });
            })
        }
    }

    onSelectChange = selectedRowKeys => {
        this.setState({ selectedRowKeys })
    }

    onChangeTable(pagination, sorter) {
        var query = qs.parse(this.props.location.search.slice(1));
        if (!_.isEmpty(pagination)) {
            query = {
                ...query,
                page: pagination.current,
                per_page: pagination.pageSize,
            }
        }
        if (!_.isEmpty(sorter)) {
            if (sorter.order) {
                query = {
                    ...query,
                    sort_field: sorter.field,
                    sort_type: sorter.order === 'ascend' ? 'ASC' : 'DESC'
                }
            } else {
                delete query.sort_field;
                delete query.sort_type;
            }
        }

        this.props.history.push({
            pathname: this.props.location.pathname,
            search: qs.stringify(query),
        })
    }

    toggleOpenForm(isOpenForm, currentItem = null) {
        this.setState({
            isOpenForm: isOpenForm,
            currentItem: currentItem
        });
    }

    onEdit(id) {
        this.props.getOneProductWarehouse(id).then((res) => {
            this.toggleOpenForm(true, res)
        })
    }

    onRemove() {
        this.props.removeProductWarehouse(this.state.selectedRowKeys).then(() => {
            this.setState({
                selectedRowKeys: [],
            })
            setTimeout(() => {
                Modal.destroyAll();
            }, 800)
        })
    }

    reloadData() {
        this.setState({
            isLoading: true
        });
        this.props.getAllProductWarehouse().then(() => {
            this.setState({
                isLoading: false
            })
        })
    }

    onChangeFilter(name, value) {
        var query = qs.parse(this.props.location.search.slice(1));
        query = {
            ...query,
            [name]: value
        }

        query = cleanObject(query);

        this.props.history.push({
            pathname: this.props.location.pathname,
            search: qs.stringify(query)
        })
    }

    render() {
        var {
            selectedRowKeys,
            isLoading,
            isOpenForm,
            currentItem
        } = this.state;
        const { product_warehouse_list, pagination } = this.props;
        var query = qs.parse(this.props.location.search.slice(1));
        var hasSelected = selectedRowKeys.length > 0;

        const rowSelection = {
            selectedRowKeys,
            onChange: this.onSelectChange,
        };

        const columns = [
            {
                title: 'ID',
                dataIndex: 'id',
                key: 'id',
                width: '50px'
            },
            {
                title: 'Tên kho hàng',
                dataIndex: 'name',
                key: 'name'
            },
            {
                title: 'Mã kho',
                dataIndex: 'code',
                key: 'code',
                width: '100px'
            },
            {
                title: 'Địa chỉ',
                dataIndex: 'address',
                key: 'address',
                width: '200px',
                render: (text, record) => {
                    return (
                        <div style={{ wordBreak: "break-word" }}>
                            <Tooltip title={HtmlParser(text)} placement="topLeft">
                                <TextTruncate line={1} truncateText="…" text={stripHtml(text)} />
                            </Tooltip>
                        </div>
                    )
                }
            },
            {
                title: 'Ghi chú',
                dataIndex: 'note',
                key: 'note',
                width: '200px',
                render: (text, record) => {
                    return (
                        <div style={{ wordBreak: "break-word" }}>
                            <Tooltip title={HtmlParser(text)} placement="topLeft">
                                <TextTruncate line={1} truncateText="…" text={stripHtml(text)} />
                            </Tooltip>
                        </div>
                    )
                }
            },
            {
                title: 'Trạng thái',
                dataIndex: 'status',
                key: 'status',
                align: 'center',
                width: '100px',
                render: (text, record) => {
                    if (text == 1) return <CheckCircleTwoTone twoToneColor="#52c41a" />;
                    if (text == 0) return <CloseCircleTwoTone twoToneColor="#e74c3c" />;
                }
            },
            {
                title: 'Ngày tạo',
                dataIndex: 'created_at',
                key: 'created_at',
                sorter: true,
                width: '150px',
                render: (text, record) => {
                    return (<div>
                        {
                            <div>{isValidDate(text)}</div>
                        }
                    </div>
                    )
                }
            },
            {
                title: 'Người tạo',
                width: '150px',
                dataIndex: 'created_username',
                key: 'created_username'
            },
        ];
        if (checkPermission('product_warehouse', 'update')) {
            columns.push({
                title: 'Actions',
                align: 'center',
                width: '80px',
                render: (text, record) => (
                    <EditOutlined onClick={() => this.onEdit(record.id)} />
                )
            })
        }

        return (
            <div>
                <PageTitle routes={routes} title="Danh sách kho" />
                <div>
                    <TableActionBar
                        isShowAddButton={checkPermission('product_warehouse', 'create')}
                        isShowDeleteButton={checkPermission('product_warehouse', 'remove')}
                        onAdd={() => this.toggleOpenForm(true)}
                        disabled={!selectedRowKeys.length ? true : false}
                        onDelete={() => this.onRemove()}
                        addText="Thêm kho mới"
                        showSearch={true}
                        showFilter={false}
                        activeFilter={query.status}
                        onSearch={(value) => this.onChangeFilter('keyword', value)}
                        defaultKeyword={query.keyword}
                    >
                        {
                            hasSelected ? <span>Đang chọn {selectedRowKeys.length} bản ghi </span> : ''
                        }
                    </TableActionBar>
                </div>

                <Table
                    rowKey='id'
                    size='small'
                    tableLayout="auto"
                    columns={columns}
                    rowSelection={rowSelection}
                    loading={isLoading}
                    dataSource={product_warehouse_list}
                    pagination={{
                        pageSize: pagination.perPage,
                        current: pagination.currentPage,
                        total: pagination.total,
                        showTotal: total => `Tổng ${total} bản ghi`
                    }}
                    onChange={(pagination, filter, sorter) => this.onChangeTable(pagination, sorter)}
                    scroll={{
                        x: 'max-content'
                    }}
                />
                <WarehouseForm
                    visible={isOpenForm}
                    currentItem={currentItem}
                    onCancel={() => this.toggleOpenForm(false)}
                    reloadData={() => this.reloadData()}
                />
            </div>
        )
    }
}

const mapStateToProps = state => {
    return {
        product_warehouse_list: state.ProductWarehouseReducer.product_warehouse_list,
        pagination: state.ProductWarehouseReducer.pagination,
    }
}

const mapDispatchToProps = dispatch => {
    return {
        getAllProductWarehouse: filter => dispatch(getAllProductWarehouse(filter)),
        getOneProductWarehouse: id => dispatch(getOneProductWarehouse(id)),
        removeProductWarehouse: ids => dispatch(removeProductWarehouse(ids))
    }
}


export default connect(mapStateToProps, mapDispatchToProps)(WarehouseList);
